export const ADD_COMPLAINT_QUESTION = "ADD_COMPLAINT_QUESTION";
export const ADD_COMPLAINT_QUESTION_SUCCESS = "ADD_COMPLAINT_QUESTION_SUCCESS";
export const ADD_COMPLAINT_QUESTION_FAIL = "ADD_COMPLAINT_QUESTION_FAIL";

export const GET_ADDED_COMPLAINT_QUESTION = "GET_ADDED_COMPLAINT_QUESTION";
export const GET_ADDED_COMPLAINT_QUESTION_SUCCESS = "GET_ADDED_COMPLAINT_QUESTION_SUCCESS";
export const GET_ADDED_COMPLAINT_QUESTION_FAIL = "GET_ADDED_COMPLAINT_QUESTION_FAIL";

export const DELETE_COMPLAINT_QUESTION = "DELETE_COMPLAINT_QUESTION";
export const DELETE_COMPLAINT_QUESTION_SUCCESS = "DELETE_COMPLAINT_QUESTION_SUCCESS";
export const DELETE_COMPLAINT_QUESTION_FAIL = "DELETE_COMPLAINT_QUESTION_FAIL";

export const EDIT_COMPLAINT_QUESTION = "EDIT_COMPLAINT_QUESTION";
export const EDIT_COMPLAINT_QUESTION_SUCCESS = "EDIT_COMPLAINT_QUESTION_SUCCESS";
export const EDIT_COMPLAINT_QUESTION_FAIL = "EDIT_COMPLAINT_QUESTION_FAIL";

export const ARRANGE_COMPLAINT_QUES_ORDER = "ARRANGE_COMPLAINT_QUES_ORDER";
export const ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS = "ARRANGE_COMPLAINT_QUES_ORDER_SUCCESS";
export const ARRANGE_COMPLAINT_QUES_ORDER_FAIL = "ARRANGE_COMPLAINT_QUES_ORDER_FAIL";

export const GET_COMPLAINT_REGISTER = "GET_COMPLAINT_REGISTER";
export const GET_COMPLAINT_REGISTER_SUCCESS = "GET_COMPLAINT_REGISTER_SUCCESS";
export const GET_COMPLAINT_REGISTER_FAIL = "GET_COMPLAINT_REGISTER_FAIL";

export const GET_COMPLAINT_FORM = "GET_COMPLAINT_FORM";
export const GET_COMPLAINT_FORM_SUCCESS = "GET_COMPLAINT_FORM_SUCCESS";
export const GET_COMPLAINT_FORM_FAIL = "GET_COMPLAINT_FORM_FAIL";

export const GET_COMPLAINT_FORM_PREVIEW = "GET_COMPLAINT_FORM_PREVIEW";
export const GET_COMPLAINT_FORM_PREVIEW_SUCCESS = "GET_COMPLAINT_FORM_PREVIEW_SUCCESS";
export const GET_COMPLAINT_FORM_PREVIEW_FAIL = "GET_COMPLAINT_FORM_PREVIEW_FAIL";

// not in use
export const REVIEW_COMPAINT_FORM = "REVIEW_COMPAINT_FORM";
export const REVIEW_COMPAINT_FORM_SUCCESS = "REVIEW_COMPAINT_FORM_SUCCESS";
export const REVIEW_COMPAINT_FORM_FAIL = "REVIEW_COMPAINT_FORM_FAIL";
